<template>
	<section class="franchaise_inn franchise_dsk container-wrap">
		<div class="container-box">
			<!-- Left Side List -->
			<div class="d-flex align-items-start">
				<div class="franchaise_inn_lt">
					<div
						v-for="menu in sidebarMenus"
						:key="menu.section + '-menu'"
						class="franchise_inn_contentbox"
					>
						<h6>{{ menu.section }}</h6>

						<div
							class="nav flex-column nav-pills"
							role="tablist"
							aria-orientation="vertical"
						>
							<button
								v-for="item in menu.items"
								:key="item.key + '-item'"
								class="nav-link"
								:class="{ active: activeTab === item.key }"
								@click="setActiveTab(item)"
								type="button"
								role="tab"
							>
								{{ item.label }}
							</button>
						</div>
					</div>
				</div>

				<!-- Right Side Content -->
				<div class="franchaise_inn_rt">
					<h2 class="franchaise_title">
						JP WORLD PAY
						{{ $t('new_ui.franchaise_page.section_banner.title.one') }}
						{{ $t('new_ui.franchaise_page.section_banner.title.two') }}
					</h2>

					<div v-for="menu in sidebarMenus" :key="menu.section">
						<div
							v-for="item in menu.items"
							:key="item.key"
							v-show="activeTab === item.key"
							class="tab-content-section"
						>
							<component :is="item.component" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<TermsMobile />
</template>

<script>
import franchaise from '@/assets/images/sub/franchaise_ban.png';
import line_arow from '@/assets/images/sub/line_arow.png';

// components
import TermsMobile from '@/components/NewUi/Components/Terms/TermsMobile.vue';
// import Sidebar menu
import { SIDEBAR_MENUS_TERMS } from '@/common/constants.js';
export default {
	name: 'Franchaise',
	components: {
		TermsMobile,
	},
	data() {
		return {
			img: {
				image1: franchaise,
				image2: line_arow,
			},
			activeTab: window.history.state?.activeTab || 'franchise-home', // Set default active tab
			sidebarMenus: SIDEBAR_MENUS_TERMS,
		};
	},
	methods: {
		setActiveTab(item) {
			const currentPathName = window.location.pathname;
			const itemPath = item.url;
			if (currentPathName === itemPath) {
				const tabName = item.key; // Get the key of the clicked item
				this.activeTab = tabName;
			} else {
				// In the source page/component
				this.$router.push({
					path: item.url,
					state: { activeTab: item.key }, // Pass the active tab key as state
				});
			}
		},
	},
};
</script>
